import { GeoJsonCollection } from '../expansion/features-buffer-geom-translator.js';
import {
  EMPTY_TILE,
  FeaturesServiceMeshData,
} from '../types/features-service-mesh-data.js';

export class FeaturesServiceDecoder {
  public initialTile: ArrayBuffer | null = null;
  public baseHeight: number | null = null;
  public maxHeight: number | null = null;
  public minHeight: number | null = null;
  public initialBaseHeight: number | null = null;

  constructor(
    private readonly tileFetcher: (
      x: number,
      y: number,
      z: number,
      abortController: AbortController
    ) => Promise<{ data: GeoJsonCollection | null; status: number }>
  ) {}

  public async fetchAndDecode(
    tile: { x: number; y: number; z: number },
    abortController: AbortController
  ): Promise<FeaturesServiceMeshData> {
    if (abortController.signal.aborted) {
      return EMPTY_TILE;
    }

    const { data } = await this.tileFetcher(
      tile.x,
      tile.y,
      tile.z,
      abortController
    );

    // Cache the sentinel so the tile is not re-fetched on subsequent frames.
    if (!data) {
      return EMPTY_TILE;
    }

    // NOTE: `data` is GeoJSONCollection, initiated from fetcher in featuresService.loadModel():MapViewer.tsx
    return data;
  }
}
